import React, { useState, useRef, useEffect } from 'react';

const CustomBlogTextArea = ({ value, onChange, hint, textareaLineHeight, maxRows, handleSelection, handleKeyDown, handleOnContextMenu }) => {
  const [rows, setRows] = useState(1);
  const textareaRef = useRef(null);

  useEffect(() => {

    textareaRef.current.rows = 1;
    const currentRows = Math.floor(textareaRef.current.scrollHeight / textareaLineHeight);

    if (currentRows >= maxRows) {
      textareaRef.current.rows = maxRows;
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    } else {
      textareaRef.current.rows = currentRows;
    }

    setRows(currentRows < maxRows ? currentRows : maxRows);
  }, [value, maxRows, rows, textareaLineHeight]);

  return (
    <textarea
      ref={textareaRef}
      rows={rows}
      value={value}
      onChange={onChange}
      placeholder={hint}
      onSelect={handleSelection && handleSelection}
      onKeyDown={handleKeyDown}
      onContextMenu={handleOnContextMenu}
      style={{ 
        overflowY: rows >= maxRows ? 'auto' : 'hidden',
        borderRadius: rows > 2 ? '10px':'999px'

      }}
    />
  );
};
export default CustomBlogTextArea;